<script>
export default {
  name: "RubricBuilderCreateHeader",
  props: {
    name: {
      type: String,
      required: true,
    },
    canValidate: {
      type: Boolean,
      default: false,
    },
    flexibleScoring: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="rubric-info-container">
    <eg-b-row>
      <eg-b-col md="6" class="column">
        <eg-input
          ref="nameInput"
          :value="name"
          :label="$t('rubrics.nameField')"
          :placeholder="$t('rubrics.rubricNamePlaceholder')"
          size="medium"
          :state="
            canValidate
              ? Boolean(name?.trim().length) && name.trim().length <= 255
                ? 'default'
                : 'error'
              : 'default'
          "
          :message="
            canValidate && name?.trim().length === 0
              ? $t('rubrics.nameRequired')
              : canValidate && name.trim().length >= 255
              ? $t('rubrics.nameTooLong')
              : ''
          "
          :show-validation="canValidate"
          @input="$emit('update:name', $event)"
        />
      </eg-b-col>
      <eg-b-col
        md="6"
        class="column"
        data-testid="rubric-builder-flexible-scoring"
      >
        <div class="flexible-scoring-container">
          <div class="flexible-scoring-label-wrapper">
            <span class="flexible-scoring-label">{{
              $t("flexibleScoring.title")
            }}</span>
            <eg-button
              type="ordinary"
              icon="information"
              color="var(--color-icon-neutral-neutral)"
              icon-size="small"
              size="extra-small"
              @click="
                $eventBus.$emit(
                  'onboarding:clicked:createRubricFlexibleScoring'
                )
              "
            />
          </div>
          <div class="flexible-scoring-content">
            <eg-toggle
              :value="flexibleScoring"
              :checked-value="true"
              :unchecked-value="false"
              :aria-label="$t('flexibleScoring.title')"
              @input="$emit('update:flexible-scoring', $event)"
            />
            <p class="flexible-scoring-description">
              {{
                flexibleScoring
                  ? $t("flexibleScoring.descriptionOn")
                  : $t("flexibleScoring.descriptionOff")
              }}
            </p>
          </div>
        </div>
      </eg-b-col>
    </eg-b-row>

    <slot name="before-criteria"></slot>
  </div>
</template>

<style lang="scss" scoped>
.rubric-info-container {
  border-radius: var(--radius-rd-400, 12px);
  border: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
  background: var(--color-surface-neutral-cardBackground, #fff);
  padding: 1rem;
}

.flexible-scoring-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.flexible-scoring-label-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.flexible-scoring-label {
  color: var(--color-text-neutral-on-white, #1a1a1a);
  font-size: var(--typography-font-size-fs-300);
  font-weight: var(--typography-font-weight-fw-500, 500);
  line-height: 1.5rem;
}

.flexible-scoring-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.flexible-scoring-description {
  color: var(--color-text-neutral-subtle, #6b7280);
  font-size: var(--typography-font-size-fs-200);
  font-weight: var(--typography-font-weight-fw-400, 400);
  margin: 0;
  line-height: 1.5;
  flex: 1;
}

.rubric-info-container {
  ::v-deep {
    .row:first-of-type {
      .column:first-of-type {
        padding-right: 1.5rem;
        .column:first-of-type {
          padding-right: 1.5rem;
          border-left: 1px solid var(--color-stroke-neutral-default);
        }
        .column:nth-of-type(2) {
          padding-left: 1.5rem;
        }
      }
    }
  }
}
</style>
